import { Subscription } from 'rxjs';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { TranslocoService } from '@ngneat/transloco';
import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { Router } from '@angular/router';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { TexttemplateModel } from 'projects/core/src/lib/models/texttemplate.model';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-texttemplate-list',
  templateUrl: './texttemplate-list.component.html',
  styleUrls: ['./texttemplate-list.component.scss']
})
export class TexttemplatesListComponent extends BaseList implements OnInit, OnDestroy {

  public allTexttemplates: Array<TexttemplateModel> = [];
  public texttemplates: Array<TexttemplateModel> = [];
  public apiUrl = '/contents/texttemplates';
  public subscriptions: Array<Subscription> = [];

  public types: Array<SelectItem> = [
    {
      label: this.transloco.translate('common.labels.mail'),
      value: 'mail'
    },
    {
      label: this.transloco.translate('common.labels.text'),
      value: 'text'
    },
  ];

  protected rightLoad = 'admin.texttemplate.list';
  protected rightNew = 'admin.texttemplate.create';
  protected rightOpen = 'admin.texttemplate.show';

  public form = this.fb.group({
    show_inactive: new UntypedFormControl(localStorage.getItem('texttemplate-list-show-inactive') === 'true')
  });

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected transloco: TranslocoService,
    protected auth: AuthStateService,
    private fb: UntypedFormBuilder,
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.loadList();
    this.subscriptions.push(this.form.get('show_inactive').valueChanges.subscribe((value: boolean) => {
      localStorage.setItem('texttemplate-list-show-inactive', value.toString());
      this.setListData();
    }));
  }

  ngOnDestroy(): void {
    this.helper.unsetSubscriptions(this.subscriptions);
  }

  loadList(): void {
    this.loading = true;
    this.api.getModels('texttemplates').subscribe({
      next: (result: any) => {
        this.allTexttemplates = result.data.map((ac: any) => {
          return new TexttemplateModel().deserialize(ac);
        });
        this.setListData();
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

  private setListData(): void {
    this.texttemplates = this.allTexttemplates.filter((texttemplate: TexttemplateModel) => {
      return this.form.get('show_inactive').value === true || texttemplate.migrated === true;
    });
  }

}
